var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowDownWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.822183 1.02213C1.25176 0.592557 1.94824 0.592557 2.37782 1.02213L6 4.64432L9.62218 1.02213C10.0518 0.592557 10.7482 0.592557 11.1778 1.02213C11.6074 1.45171 11.6074 2.14819 11.1778 2.57777L6.77782 6.97777C6.34824 7.40735 5.65176 7.40735 5.22218 6.97777L0.822183 2.57777C0.392606 2.14819 0.392606 1.45171 0.822183 1.02213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowDownWhite);
export default __webpack_public_path__ + "static/media/row-down-white.2d33356b.svg";
export { ForwardRef as ReactComponent };